import VocPagination from "./src/main"

/* istanbul ignore next */
VocPagination.install = function (Vue) {
  Vue.component(VocPagination.name, VocPagination)
}

export default VocPagination
